import {CityProps, translatedCityProps} from 'modules/cities/types';
import {
  NeighborhoodProps,
  translatedNeighborhoodProps,
} from 'modules/neighborhoods/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface AddressProps {
  id: string;
  name: string;
  cityId: string;
  city: CityProps;
  state: string;
  latitude: number;
  longitude: number;
  number: string;
  neighborhoodId: string;
  neighborhood: NeighborhoodProps;
  street: string;
  reference?: string;
  complement?: string;
}

export const translatedAddressProps: TranslatedKeys<AddressProps> = {
  reference: 'Referência',
  cityId: 'Cidade',
  city: {...translatedCityProps, name: 'Cidade'},
  latitude: 'Latitude',
  longitude: 'Longitude',
  name: 'Nome',
  state: 'Estado',
  neighborhoodId: 'Bairro',
  neighborhood: {...translatedNeighborhoodProps, name: 'Bairro'},
  number: 'Número',
  street: 'Rua',
  complement: 'Complemento',
};
